export const ETHNICITY = {
    h: {
        en: 'Hispanic/Latino',
        es: 'Hispano/Latino'
    },
    np: {
        en: 'Non-Hispanic/Latino',
        es: 'No Hispano/Latino'
    }
} as Record<string, { en: string; es: string }>;
